__turbopack_context__.v({
  "closing": "IvLoungeBenefitsSection-module__Q0fEIW__closing",
  "contentColumn": "IvLoungeBenefitsSection-module__Q0fEIW__contentColumn",
  "headingColumn": "IvLoungeBenefitsSection-module__Q0fEIW__headingColumn",
  "intro": "IvLoungeBenefitsSection-module__Q0fEIW__intro",
  "pointerIndex": "IvLoungeBenefitsSection-module__Q0fEIW__pointerIndex",
  "pointerList": "IvLoungeBenefitsSection-module__Q0fEIW__pointerList",
  "pointerRow": "IvLoungeBenefitsSection-module__Q0fEIW__pointerRow",
  "pointerTitle": "IvLoungeBenefitsSection-module__Q0fEIW__pointerTitle",
  "shell": "IvLoungeBenefitsSection-module__Q0fEIW__shell",
});
